import React from "react";
import "../Styles/Title.css";

const Title = ({ title }) => {
  return <div className="title-questionaire my-3">{title}</div>;
};

export default Title;
